import { InspectorControls } from '@wordpress/block-editor';
import CounterSettings from './counter-settings';
import DataSourceControls from './data-source-controls';
import IconControls from './icon-controls';
import CircleControls from './circle-controls';
import StyleControls from './style-controls';

export default function AllInspectorControls( {
	attributes,
	setAttributes,
	setIsIconsModalOpen,
} ) {
	const isNumber = attributes.type === 'number';

	return (
		<InspectorControls>
			<CounterSettings
				attributes={ attributes }
				setAttributes={ setAttributes }
			/>
			<DataSourceControls
				attributes={ attributes }
				setAttributes={ setAttributes }
			/>
			<IconControls
				attributes={ attributes }
				setAttributes={ setAttributes }
				setIsIconsModalOpen={ setIsIconsModalOpen }
			/>
			{ ! isNumber && (
				<CircleControls
					attributes={ attributes }
					setAttributes={ setAttributes }
				/>
			) }
			<StyleControls
				attributes={ attributes }
				setAttributes={ setAttributes }
			/>
		</InspectorControls>
	);
}
